static function toJSON() {
  // Only serialize the following to the browser if we are a top level component.
  return {
    type: this.type,
    noHover: this.noHover,
    overlayId: this.overlayId
  };
}
$ input.toJSON = toJSON;
$ const {
  overlayStyle,
  renderBody
} = input;
<span key="container" on-expander-expand("handleExpand") on-expander-collapse("handleCollapse") overlay-style=overlayStyle>
  <${renderBody}/>
</span>